export default class ProgressButton {
    private el: JQuery<HTMLElement>;

    constructor(el: any) {
        this.el = $(el);
    }

    set progress(val: boolean) {
        this.el
            .toggleClass('btn-in-progress', val)
            .prop('disabled', val);
    }
}